<jqxLoader #loader style="background-color: rgba(185, 219, 233, 0.7);" [imagePosition]="'top'" [width]="95"
    [height]="55" [text]="'Procesando...'">
</jqxLoader>
<div class="main">
    <app-confirm-dialog></app-confirm-dialog>
    <div style="float: left; clear: both; width: 1594px; height: 60px; background-color: #252841;">
        <div style="float: left;">
            <img src="/assets/images/movisat.png" style="float: left; width: 150px; height: 50px;" />
            <div class="vertical-line"></div>
            <div style="float: left; padding-top: 13px; padding-left: 10px; font-size: 18px; color: white;">
                <span>
                    Importación de elementos y móviles de EcoSAT
                </span><span style="margin-left: 150px;">{{getEnvironment()}}</span>
            </div>
        </div>
        <div style="float:right; padding-top: 15px; margin-right: 6px;">
            <div style="float: right; margin-right: 6px;">
                <div
                    style="float: left; padding-right: 10px; padding-top: 10px; color: rgb(142, 186, 243); font-size: 90%;">
                    {{apiService.getTicket() ? apiService.getTicket().Usuario.Nombre : ''}}
                </div>
                <img id="popoverButton" src="/assets/images/usuario.png" class="avatarProfile" />
                <jqxPopover [theme]="environment.tema" [selector]="'#popoverButton'" [arrowOffsetValue]="50"
                    [offset]="{ left: -50, top: 0 }">
                    <div>{{ apiService.getTicket() ? apiService.getTicket().Usuario.Email : '' }}</div>
                    <hr />
                    <div>
                        <button class="enlace" role="link" (click)="apiService.endAppSession()">
                            Cerrar sesion
                        </button>
                    </div><br>
                </jqxPopover>
            </div>
        </div>
    </div>
    <jqxRibbon style="padding-top: 4px; overflow: hidden; background-color: rgb(222, 248, 215)"
        [theme]="environment.tema" [width]="'1594px'" [height]="'100%'" [position]="'top'">
        <ul style="width: 256px; text-align: center; background-color: rgb(222, 248, 215); border-width: 0px;">
            <li id="tab0" style="height: 30px; vertical-align: middle;" (click)="onClickTab(0)">
                <b>Equipamientos</b>
            </li>
            <li id="tab1" style="margin-left: 4px; height: 30px; vertical-align: middle;" (click)="onClickTab(1)">
                <b>Recursos</b>
            </li>
        </ul>
        <div style="margin-top: 10px;">
            <div style="overflow: hidden; border-width: 0px; background-color: rgb(222, 248, 215)">
                <div style="float:left; width: 310px; height: 380px;">
                    <div style="float: left; clear: both; font-size: 14px;">
                        <b>Empresa origen</b><br>
                        <jqxDropDownList #cbEmpresas style="float:left; overflow-x: hidden;" [width]="310" [height]="25"
                            [selectedIndex]="0" [autoDropDownHeight]="false" (onSelect)="onSelectEmpresa($event)">
                        </jqxDropDownList>
                        <b>Empresa destino</b><br>
                        <jqxDropDownList #cbEmpresasNP style="float:left; margin-top: 4px; overflow-x: hidden;"
                            [width]="310" [height]="25" [selectedIndex]="0" [autoDropDownHeight]="false"
                            (onSelect)="onSelectEmpresaNP($event)">
                        </jqxDropDownList>
                    </div>
                    <div style="float: left; padding-top: 8px; clear: both; font-size: 14px;">
                        <b>Url API Nueva Plataforma</b><br>
                        <jqxInput #ebUrlApi [(ngModel)]="urlApi" [width]="310" [height]="25">
                        </jqxInput>
                    </div>
                    <div style="float: left; padding-top: 8px; clear: both; font-size: 14px;">
                        <b>Url API EcoSAT</b><br>
                        <jqxInput #ebUrlApiEcoSAT [(ngModel)]="urlApiEcoSAT" [width]="310" [height]="25">
                        </jqxInput>
                    </div>
                    <div style="float: left; padding-top: 8px; clear: both; font-size: 14px;">
                        <b>Url de la aplicación Web</b><br>
                        <div style="width: 310px; height: 25px; font-size: 13px;">
                            {{urlNP}}
                        </div>
                    </div>
                    <div style="margin-top: 8px; float:left; padding-bottom: 4px; clear: both;">
                        Borrar catálogo de equipamiento
                        <input [(ngModel)]="borrarEquipamiento" type='checkbox' /><br>
                    </div>
                    <div style="float:left; clear: both;">
                        Borrar elementos antes de crear
                        <input [(ngModel)]="borrarElementos" type='checkbox' /><br>
                    </div>
                    <div style="float:left; clear: both;">
                        Importar móviles
                        <input [(ngModel)]="importarMoviles" type='checkbox' /><br><br>
                    </div>
                    <div *ngIf="!conectando && !cancelar && !procesando"
                        style="float: left; margin-left: 190px; clear: both;">
                        <jqxButton #btnConectar style="float: left; padding: 4px;" [width]='120' [height]='27'
                            (onClick)="onConectar($event)">
                            Iniciar conexión
                        </jqxButton>
                    </div>
                    <div *ngIf="conectando || procesando" style="float: left; margin-left: 235px; clear: both;">
                        <jqxButton #btnConectar style="float: left; padding: 4px;" [width]='75' [height]='27'
                            (onClick)="onCancelar($event)">
                            Cancelar
                        </jqxButton>
                    </div>
                    <div *ngIf="!procesoCancelado && !procesando"
                        style="float: left; margin-left: 160px; margin-top:4px; clear: both;">
                        <jqxButton #btnProcesar style="float: left; padding: 4px;" [width]='150' [height]='27'
                            (onClick)="onProcesarElementos($event)">
                            Importar elementos
                        </jqxButton>
                    </div>
                </div>
                <div style="float:left; margin-left: 5px; width: 1278px; height: 390px;">
                    <div style="float: left; font-size: 15px;">
                        <b>Modelos de elementos EcoSAT</b><br>
                        <jqxGrid #gridEcoSAT [theme]="environment.tema" [width]="'466px'" [height]="'370px'"
                            [source]="dataAdapterEcoSAT" [columnsresize]="true" [filterable]="true"
                            [showfilterrow]="false" [filtermode]="'excel'" [selectionmode]="'checkbox'"
                            [columns]="columnsEcoSAT" [sortable]="true" [altrows]="true" [showrowlines]="false"
                            [filterrowheight]="30" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                            [showaggregates]="true" [showstatusbar]="true" [statusbarheight]="20"
                            [columnmenuopening]="onColumnMenuOpening" [columnmenuclosing]="onColumnMenuClosing"
                            [localization]="langGrid">
                        </jqxGrid>
                    </div>
                    <div style="float: left; margin-left: 5px; font-size: 15px;">
                        <b>Equipamientos BDT</b>
                        <div style="margin-right: 0px; float:right; clear: both;">
                            Incluir equipamientos generales
                            <input [(ngModel)]="verEquipamientoGral" type='checkbox' /><br>
                        </div>
                        <jqxGrid #gridBDT [theme]="environment.tema" [width]="'803px'" [height]="'338px'"
                            [source]="dataAdapterBDT" [columnsresize]="true" [filterable]="true" [showfilterrow]="false"
                            [filtermode]="'excel'" [selectionmode]="'singlerow'" [columns]="columnsBDT"
                            [sortable]="true" [altrows]="true" [showrowlines]="false" [filterrowheight]="30"
                            [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true" [showaggregates]="true"
                            [showstatusbar]="true" [statusbarheight]="20" [columnmenuopening]="onColumnMenuOpening"
                            [columnmenuclosing]="onColumnMenuClosing" [localization]="langGrid"
                            (onRowclick)="onRowClickEquipamiento($event)">
                        </jqxGrid>
                        <div style="float: left; padding-top: 5px;">
                            <jqxButton #btnAddModel [width]='130' [height]='27' (onClick)="onAddModels($event)">
                                Añadir modelos
                            </jqxButton>
                        </div>
                        <div style="float: left; padding-left: 5px; padding-top: 5px;">
                            <jqxButton #btnDelModel [width]='130' [height]='27' (onClick)="onDeleteModels($event)">
                                Quitar modelos
                            </jqxButton>
                        </div>
                    </div>
                </div>
                <div id="secondArea" class="secondArea">
                    <div id="logArea0" class="logArea">
                    </div>
                    <div style="float: left; padding-left: 5px; font-size: 14px;">
                        <b>Modelos asignados al equipamiento</b><br>
                        <jqxGrid #gridEcoSAT2 [theme]="environment.tema" [width]="'804px'" [height]="'244px'"
                            [source]="dataAdapterEcoSAT2" [columnsresize]="true" [filterable]="true"
                            [showfilterrow]="false" [filtermode]="'excel'" [selectionmode]="'checkbox'"
                            [columns]="columnsEcoSAT2" [sortable]="true" [altrows]="true" [showrowlines]="false"
                            [filterrowheight]="30" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                            [showaggregates]="true" [showstatusbar]="true" [statusbarheight]="20"
                            [columnmenuopening]="onColumnMenuOpening" [columnmenuclosing]="onColumnMenuClosing"
                            [localization]="langGrid">
                        </jqxGrid>
                    </div>
                </div>
            </div>
            <div style="overflow: hidden; border-width: 0px; background-color: rgb(222, 248, 215);">
                <div style="float: left; clear: both; font-size: 14px;">
                    <b>Empresa origen</b><br>
                    <jqxDropDownList #cbEmpresas2 style="float:left; overflow-x: hidden;" [width]="310" [height]="25"
                        [selectedIndex]="0" [autoDropDownHeight]="false" (onSelect)="onSelectEmpresa2($event)">
                    </jqxDropDownList><br>
                    <b>Empresa destino</b><br>
                    <jqxDropDownList #cbEmpresasNP2 style="float:left; margin-top: 4px; overflow-x: hidden;"
                        [width]="310" [height]="25" [selectedIndex]="0" [autoDropDownHeight]="false"
                        (onSelect)="onSelectEmpresaNP2($event)">
                    </jqxDropDownList>
                </div>
                <div style="margin-top: 10px; float:left; padding-bottom: 4px; clear: both;">
                    Crear empresa
                    <input [(ngModel)]="crearEmpresa" type='checkbox' /><br>
                </div>
                <div style="float: left; padding-top: 6px; margin-left: 180px; clear: both;">
                    <jqxButton #btnProcesar style="float: left; padding: 4px;" [width]='130' [height]='27'
                        (onClick)="onProcesarMoviles($event)">
                        Importar móviles
                    </jqxButton>
                </div>
                <div style="float: left; margin-top: 20px; clear: both; height: 605px;">
                    <div id="logArea1" class="logArea">
                    </div>
                </div>
            </div>
        </div>
    </jqxRibbon>
    <div style="width: 1592px; text-align: center; clear: both;">
        Copyright <a href="http://www.movisat.com" target="_blank">Movisat</a> © {{anno}}
        <span style="float: right;"><sub>versión {{version}}</sub></span>
    </div>
</div>